import PropTypes from "prop-types";
import React, { use, useEffect } from "react";
import { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

const RejectModal = ({ show, type, onRejectClick, onCloseClick }) => {
  const [reason, setReason] = useState(null);
  const [reasonList, setReasonList] = useState([]);

  useEffect(() => {
    switch (type) {
      case "initial":
        setReasonList([
          "Meltable Product",
          "Brand Restricted",
          "ASIN Restricted",
          "Weight Restricted",
          "Size Restricted",
          "Not Profitable - Current Price",
          "ATL Fail",
          "Not Profitable - Avg Price",
          "Product Mismatch",
        ]);
        break;
      case "stock":
        setReasonList([          
          "Lead time too long",
          "Product Mismatch",
          "Out of Stock",
          "Low Stock >10",
          "Brand Restricted",
          "Expiry Date",
        ]);
        break;
      case "final":
        setReasonList([
          "Meltable Product",
          "Brand Restricted",
          "ASIN Restricted",
          "Weight Restricted",
          "Size Restricted",
          "Not Profitable - Current Price",
          "ATL Fail",
          "Not Profitable - Avg Price",
          "Product Mismatch",
          "Lead time too long",
          "Product Mismatch",
          "Out of Stock",
          "Low Stock >10",
          "Brand Restricted",
          "Expiry Date",
          "Estimated Sales Low",
          "Per Member Order Weight Too High",
          "Total Supplier Order Value Too High",
          "Total Supplier Order Value below MOV",
          "Total Member Order Value Too High",
          "Total Member Order Value Too Low",
          "Too many sellers",
          "MOQ Too High",
        ]);
        break;
    }
  }, [type]);

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you sure ?</h4>
            <p className="text-muted mx-4 mb-0">Reason for Rejection</p>
          </div>
          <select
            className="form-control w-md"
            data-choices
            data-choices-search-false
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="" defaultValue>
              Choose a Reason
            </option>
            {reasonList.map((reason) => (
              <option key={reason} value={reason}>
                {reason}
              </option>
            ))}
          </select>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Close
          </button>
          <button
            type="button"
            disabled={!reason || reason === ""}
            className="btn w-sm btn-danger "
            id="delete-record"
            onClick={() => onRejectClick(reason)}
          >
            Yes, Reject It!
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

RejectModal.propTypes = {
  onCloseClick: PropTypes.func,
  onRejectClick: PropTypes.func,
  show: PropTypes.any,
};

export default RejectModal;
